import React from 'react';

interface TitleWithLanternsProps {
  title: string;
  subtitle?: string;
  lanternType: 1 | 2 | 3 | 4;
  className?: string;
  titleClassName?: string;
}

const TitleWithLanterns: React.FC<TitleWithLanternsProps> = ({ 
  title, 
  subtitle, 
  lanternType,
  className = "",
  titleClassName = "text-display-lg md:text-display-xl font-display text-white text-shadow-luxury"
}) => {
          const lanternSrc = `/restaurant_photos/lantern_${lanternType}.png`; // Placeholder for lantern images
  
  return (
    <div className={`relative z-10 text-center ${className}`}>
      <div className="relative inline-block">
        {/* Content */}
        <div>
          {subtitle && (
            <p className="text-luxury-champagne text-lg tracking-luxury uppercase font-body mb-4">
              {subtitle}
            </p>
          )}
          <h1 className={titleClassName}>
            {title}
          </h1>
          <div className="h-px bg-luxury-gold mx-auto mt-6 w-20" />
        </div>
      </div>
    </div>
  );
};

export default TitleWithLanterns;